module.exports = __webpack_public_path__ + "static/webos-6729b7630a61fa50a09a030a8d7ac23b.png";